<template>
  <ts-card>
    <div
      class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
    >
      <h4 class="ts-text-sm">
        {{ $t('stockTransfer.details') }}
      </h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <ts-loading-banner :loading="waiting">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <form>
                <fieldset>
                  <legend>
                    {{ $t('stockTransfer.transfer_info') }}
                  </legend>
                  <div class="row">
                    <div class="col-md-3 text-right">
                      {{ $t('stockTransfer.transfer') }}
                      :
                    </div>
                    <div class="col-md-3">{{ data.transfer_no }}</div>
                    <div class="col-md-3 text-right">
                      {{ $t('stockTransfer.date') }}
                      :
                    </div>
                    <div class="col-md-3">{{ data.transfer_date }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-3 text-right">
                      {{ $t('stockTransfer.from_branch') }}
                      :
                    </div>
                    <div class="col-md-3">
                      {{
                        data.from_branch ? data.from_branch.branch_name_en : ''
                      }}
                    </div>
                    <div class="col-md-3 text-right">
                      {{ $t('stockTransfer.from_location') }}
                      :
                    </div>
                    <div class="col-md-3">
                      {{
                        data.from_location
                          ? data.from_location.location_name_en
                          : ''
                      }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3 text-right">
                      {{ $t('stockTransfer.to_branch') }} :
                    </div>
                    <div class="col-md-3">
                      {{ data.to_branch ? data.to_branch.branch_name_en : '' }}
                    </div>
                    <div class="col-md-3 text-right">
                      {{ $t('stockTransfer.to_location') }}
                      :
                    </div>
                    <div class="col-md-3">
                      {{
                        data.to_location
                          ? data.to_location.location_name_en
                          : ''
                      }}
                    </div>
                    <div class="col-md-3 text-right"></div>
                    <div class="col-md-3"></div>
                  </div>
                  <div class="row">
                    <div class="col-md-3 text-right">
                      {{ $t('stockTransfer.transfered_by') }}
                      :
                    </div>
                    <div class="col-md-3">
                      {{
                        data.transferred_by
                          ? data.transferred_by.employee
                            ? data.transferred_by.employee.employee_name_en
                            : ''
                          : ''
                      }}
                    </div>
                    <div class="col-md-3 text-right">
                      {{ $t('stockTransfer.received_by') }}
                      :
                    </div>
                    <div class="col-md-3">
                      {{
                        data.received_by
                          ? data.received_by.employee
                            ? data.received_by.employee.employee_name_en
                            : ''
                          : ''
                      }}
                    </div>
                    <div class="col-md-3 text-right"></div>
                    <div class="col-md-3"></div>
                  </div>
                  <div class="row">
                    <div class="col-md-3 text-right">
                      {{ $t('stockTransfer.status') }} :
                    </div>
                    <div class="col-md-3">
                      <span :class="statusStyle(data.transfer_status_id)">{{
                        status(data.transfer_status_id)
                      }}</span>
                    </div>
                    <div class="col-md-3 text-right">
                      {{ $t('stockTransfer.total_amount') }}
                      :
                    </div>
                    <div class="col-md-3">
                      $ {{ format_number(data.total_amount) }}
                    </div>
                    <div class="col-md-3 text-right"></div>
                    <div class="col-md-3"></div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <form>
                <fieldset>
                  <legend>
                    {{ $t('stockTransfer.transfer_details') }}
                  </legend>
                  <div class="overflow-auto max-h">
                    <table class="table table-hover ui-table ts-table">
                      <thead>
                        <tr>
                          <th style="width: 15px" class="text-center">
                            {{ $t('stockTransfer.no') }}
                          </th>
                          <th style="width: 15px" class="text-center">
                            {{ $t('stockTransfer.barcode') }}
                          </th>
                          <th>
                            {{ $t('stockTransfer.product') }}
                          </th>
                          <th class="text-center">
                            {{ $t('stockTransfer.uom') }}
                          </th>
                          <th class="text-center">
                            {{ $t('stockTransfer.cost') }}
                          </th>
                          <th class="text-center">
                            {{ $t('stockTransfer.qty') }}
                          </th>
                          <th class="text-center">
                            {{ $t('stockTransfer.amount') }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(record, index) in datasource" :key="index">
                          <td class="text-center text-nowrap">
                            {{ index + 1 }}
                          </td>
                          <td class="text-center text-nowrap">
                            {{ record.product ? record.product.barcode : '' }}
                          </td>
                          <td class="text-left text-nowrap">
                            {{
                              record.product
                                ? record.product.product_name_en
                                : ''
                            }}
                          </td>
                          <td class="text-center text-nowrap">
                            {{
                              record.unit_of_measure
                                ? record.unit_of_measure.uom_name_en
                                : ''
                            }}
                          </td>
                          <td class="text-center text-nowrap">
                            $ {{ format_number(record.cost) }}
                          </td>
                          <td class="text-center text-nowrap">
                            {{ record.quantity }}
                          </td>
                          <td class="text-center text-nowrap">
                            $
                            {{ format_number(record.cost * record.quantity) }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="ts-mt-1 ts-text-right ts-font-bold text-danger">
                    TOTAL : {{ total }}
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </ts-loading-banner>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
export default {
  name: 'previewDetail',
  props: ['data'],
  data () {
    return {
      waiting: false,
      status_id: 1,
      datasource: []
    }
  },
  computed: {
    statusStyle: () => status => {
      let badge = ''

      switch (status) {
        case 1:
          badge = 'badge badge-info'
          break
        case 2:
          badge = 'badge badge-primary'
          break
        case 3:
          badge = 'badge badge-default'
          break
      }

      return badge
    },
    status: () => status => {
      let value = ''

      switch (status) {
        case 1:
          value = 'Pending'
          break
        case 2:
          value = 'Received'
          break
        case 3:
          value = 'Rejected'
          break
      }

      return value
    },
    total () {
      return _.sumBy(this.datasource, function (el) {
        return parseFloat(el.quantity)
      })
    }
  },
  created () {
    this.setDetails()
  },
  methods: {
    setDetails () {
      this.datasource = this.data.stock_transfer_details
    },
    format_number (value) {
      return parseFloat(value).toFixed(2)
    }
  }
}
</script>
<style scoped>
table > thead > tr > th,
table > tbody > tr > td {
  padding: 3px 5px;
}
.table > thead > tr > th {
  position: sticky;
  top: 0;
  z-index: 10;
}
.max-h {
  max-height: 50vh;
}
</style>
